import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { Skeleton } from '@mui/material';

const TableSkeletonLoader = ({ rowCount = 5, columnCount = 3 }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {Array.from({ length: columnCount }).map((_, index) => (
              <TableCell key={`header-skeleton-${index}`}>
                <Skeleton
                  variant='rectangular'
                  height={20}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <TableRow key={`row-skeleton-${rowIndex}`}>
              {Array.from({ length: columnCount }).map((_, colIndex) => (
                <TableCell key={`cell-skeleton-${rowIndex}-${colIndex}`}>
                  <Skeleton
                    variant='rectangular'
                    height={15}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSkeletonLoader;
